import {
  on
} from "../utils/events";
import ready from "../utils/ready";
import {
  $,
  $$
} from "../utils/selector";
import {
  attachTabs
} from "../components/tabs"

function setImgSrc(img, src) {
  if (undefined != img) {
    img.src = src;
  }
}

function setSpanText(span, text) {
  if (undefined != span) {
    if ('textContent' in span) {
      span.textContent = text;
    } else {
      span.innerText = text;
    }
  }
}

function hideError() {
  let error = $(document, '#error');
  let info = $(document, '#info');

  if (undefined != error) {
    error.classList.add("is-hidden");
  }

  if (undefined != info) {
    info.classList.remove("is-hidden");;
  }
}

function setDownloadInfoField(src, dst) {
  if ('oemSelect' == src.id) {
    if ('oemLogo' == dst.id) {
      setImgSrc(dst, '/users/oem/' + src.value + '/logo');
    } else if ('oemName' == dst.id) {
      setSpanText(dst, src.options[src.selectedIndex].text);
    } else if ('unmsLicense' == dst.id) {
      setSpanText(dst, src.value + 'OEMUX-FREE-UNMS');
    }
  } else if ('platSelect' == src.id) {
    if ('platform' == dst.id) {
      setSpanText(dst, src.options[src.selectedIndex].text);
    } else if ('version' == dst.id) {
      setSpanText(dst, src.options[src.selectedIndex].dataset.version);
    } else if ('upsmanLicense' == dst.id) {
      setSpanText(dst, src.options[src.selectedIndex].dataset.license);
    }
  } else if ('langSelect' == src.id) {
    if ('language' == dst.id) {
      setSpanText(dst, src.options[src.selectedIndex].text);
    }
  }
}

ready().then(() => {
  attachTabs(-1); // -1 means: we activate our tabs in the template

  // Show selected OEM info
  var oemSelect = $(document, '#oemSelect');
  if (undefined != oemSelect) {
    const fieldSelectors = '#oemLogo, #oemName, #unmsLicense';

    const fields = $$(document, fieldSelectors);
    for (let i = 0, l = fields.length; i < l; i++) {
      setDownloadInfoField(oemSelect, fields[i]);
    }

    // Update item download info whenever OEM selection changes
    on(oemSelect, 'change', fieldSelectors, function (event) {
      hideError();
      setDownloadInfoField(event.target, this);
    });
  }

  // Show selected platform info
  var platSelect = $(document, '#platSelect');
  if (undefined != platSelect) {
    const fieldSelectors = '#platform, #version, #upsmanLicense';

    const fields = $$(document, fieldSelectors);
    for (let i = 0, l = fields.length; i < l; i++) {
      setDownloadInfoField(platSelect, fields[i]);
    }

    // Update item download info whenever platform selection changes
    on(platSelect, 'change', fieldSelectors, function (event) {
      hideError();
      setDownloadInfoField(event.target, this);
    });
  }

  // Show selected language info
  var langSelect = $(document, '#langSelect');
  if (undefined != langSelect) {
    const fieldSelectors = '#language';

    const fields = $$(document, fieldSelectors);
    for (let i = 0, l = fields.length; i < l; i++) {
      setDownloadInfoField(langSelect, fields[i]);
    }

    // Update item download info whenever language selection changes
    on(langSelect, 'change', fieldSelectors, function (event) {
      hideError();
      setDownloadInfoField(event.target, this);
    });
  }
});
